<template>
  <div class="container-faces">
    <v-tooltip top>
      <template v-slot:activator="{ on }">
        <div class="face-dente face-lingual" :class="{'face-selecionada' : faceSelecionada === faces.lingual}" v-on="on" @click="selecionarFace(faces.lingual)"/>
      </template>
      {{ faces.lingual }}
    </v-tooltip>
    <div class="container-faces-meio">
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <div class="face-dente face-distal" :class="{'face-selecionada' : faceSelecionada === faces.distal}" v-on="on" @click="selecionarFace(faces.distal)"/>
        </template>
        {{ faces.distal }}
      </v-tooltip>
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <div class="face-dente face-oclusal" :class="{'face-selecionada' : faceSelecionada === faces.oclusal}" v-on="on" @click="selecionarFace(faces.oclusal)"/>
        </template>
        {{ faces.oclusal }}
      </v-tooltip>
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <div class="face-dente face-mesial" :class="{'face-selecionada' : faceSelecionada === faces.mesial}" v-on="on" @click="selecionarFace(faces.mesial)"/>
        </template>
        {{ faces.mesial }}
      </v-tooltip>
    </div>
    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <div class="face-dente face-vestibular" :class="{'face-selecionada' : faceSelecionada === faces.vestibular}" v-on="on" @click="selecionarFace(faces.vestibular)"/>
      </template>
      {{ faces.vestibular }}
    </v-tooltip>
  </div>
</template>

<script>
export default {
    name: 'FacesDentes',
    props: {
        faces: {
            type: Object,
            required: true
        },
        faceSelecionada: {
            type: String
        },
    },
    methods:{
        selecionarFace(face){
            if(this.faceSelecionada === face){
                this.$emit('selecionarFace', null)
                return
            }
            this.$emit('selecionarFace', face)
        }
    }
}
</script>

<style scoped lang="stylus">

.container-faces
  display flex
  flex-direction column
  align-items center

.container-faces-meio
  display flex
  flex-direction row

.face-dente
  height 25px
  width 30px
  background-color #e0e0e0
  border 1px solid black

.face-oclusal
  border none

.face-dente:hover
  cursor pointer
  border 2px solid lawngreen

.face-selecionada
  background-color var(--theme-secondary)
  
</style>